import { COUPLE_NAMES, SITE_LOGO_MARK_URL } from "../../constants/siteContent";

export default function HomeFooter() {
  return (
    <footer className="home-footer">
      <img src={SITE_LOGO_MARK_URL} alt="" width={32} height={32} className="home-footer-mark" />
      <p className="home-footer-text">
        {COUPLE_NAMES} · 8 May 2027 · Blue Mountains, NSW
      </p>
    </footer>
  );
}
